"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoThumbnail = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _axios = _interopRequireDefault(require("axios"));
var _common = require("b2b-components/theme/common");
var _jsVideoUrlParser = _interopRequireDefault(require("js-video-url-parser"));
var useVideoThumbnail = function useVideoThumbnail(videoUrl) {
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    videoThumbnail = _useState2[0],
    setVideoThumbnail = _useState2[1];
  if (!videoUrl) {
    return null;
  }
  var _urlParser$parse = _jsVideoUrlParser["default"].parse(videoUrl),
    videoId = _urlParser$parse.id;
  if (videoUrl.includes(_common.VIDEO_TYPE.youtube)) {
    return "https://img.youtube.com/vi/".concat(videoId, "/hqdefault.jpg");
  }
  if (videoUrl.includes(_common.VIDEO_TYPE.vimeo)) {
    _axios["default"].get("https://vimeo.com/api/v2/video/".concat(videoId, ".json")).then(function (response) {
      return setVideoThumbnail(response.data[0].thumbnail_large);
    });
  }
  return videoThumbnail;
};
exports.useVideoThumbnail = useVideoThumbnail;